import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function DealFlowNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Overview',
    href: '#overview'
  }, {
    name: 'Current Deals',
    href: '#current-deals'
  }, {
    name: 'Completed Deals',
    href: '#completed-deals'
  }, {
    name: 'The Report',
    href: '#deal-report'
  }, {
    name: 'Contact',
    href: '#about'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal-dark border-b border-charcoal-light' : 'bg-transparent'}`} data-id="element-250">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="flex justify-between items-center h-20" data-id="element-252">
          <a href="#hero" onClick={e => handleNavClick(e, '#hero')} className="font-editorial text-xl tracking-[0.2em] uppercase text-white" data-id="element-253">
            Cabo Deal Flow
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-254">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-xs tracking-widest uppercase text-slate-light hover:text-gold transition-colors" data-id="element-255">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-256">
            {mobileMenuOpen ? <X size={24} data-id="element-257" /> : <Menu size={24} data-id="element-258" />}
          </button>
        </div>
      </div>
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-gold/50 to-transparent opacity-50" data-id="element-259" />

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-260">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal-dark border-b border-charcoal-light overflow-hidden" data-id="element-261">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-262">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block px-3 py-4 text-white text-sm tracking-widest uppercase border-b border-charcoal" data-id="element-263">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}